var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadingglassesCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.46,247c204.72-.61,434.36-.62,639.08,0-204.72.62-434.36.61-639.08,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheets--inject-89"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "467.45 388.57 566.76 364.16 692.94 381.74 589.34 407.96 467.45 388.57",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.45,388.57l99.28-24.52S693,381.51,693,381.5l1.27.17L693,382,589.34,408.1s-121.85-19.54-121.89-19.53Zm0,0s122.08,19.27,121.86,19.26L692.88,381.5l0,.49S566.6,364.26,566.79,364.27l-99.34,24.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.39,401.16c6.11-1.88,12.41-3.63,18.73-5.36s12.74-3.39,19.18-5,13-3.24,19.58-4.77l9.92-2.29c3.38-.72,6.69-1.48,10.11-2.16-3,.95-6.18,1.82-9.27,2.74l-9.45,2.61c-6.3,1.75-12.74,3.4-19.18,5s-13,3.24-19.58,4.77S592.21,399.76,585.39,401.16Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.8,391.23c7-2.4,14.56-4.46,22.22-6.42S639.58,381,648,379.56c-7,2.41-14.55,4.46-22.22,6.42S610.17,389.75,601.8,391.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.47,397.19c6.11-1.88,12.41-3.63,18.73-5.36s12.74-3.39,19.18-5,13-3.24,19.57-4.77l9.93-2.28c3.37-.72,6.69-1.48,10.11-2.17-3,.95-6.18,1.83-9.27,2.74l-9.45,2.62c-6.31,1.74-12.74,3.39-19.18,5s-13,3.24-19.58,4.77S562.29,395.79,555.47,397.19Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.65,392.38c10.39-3.26,21.3-6.16,32.34-9s22.3-5.48,34-7.81c-10.39,3.26-21.3,6.16-32.33,9S563.39,390.05,551.65,392.38Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.63,383.33c5.73-2.08,12-3.81,18.37-5.45s13-3.12,20.07-4.28c-5.73,2.09-12,3.81-18.36,5.45S571.71,382.17,564.63,383.33Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.06 286.06 194.86 259.98 327.83 298.83 190.72 325.85 57.06 286.06",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,286.06l137.81-26.21s133,38.75,133,38.74l1,.29-1,.2L190.72,326c-.05,0-133.62-39.91-133.66-39.91Zm0,0,133.7,39.66c-.33.07,137.11-27.16,137-27.13l0,.48-132.93-39c.26-.06-137.81,26-137.77,26Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.79,317.93c9-2.08,18.07-4,27.18-5.93s18.29-3.77,27.48-5.59,18.43-3.6,27.73-5.29l13.95-2.54c4.69-.8,9.34-1.64,14.07-2.4-4.48,1.05-9,2-13.54,3L272,302.11c-9.1,1.94-18.29,3.77-27.47,5.59s-18.43,3.6-27.73,5.29S198.21,316.39,188.79,317.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.11,304.1c9.82-2.53,20-4.67,30.21-6.71s20.61-3.9,31.29-5.41c-9.82,2.53-20,4.67-30.21,6.71S234.79,302.59,224.11,304.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.2,306.86c7.85-1.86,15.81-3.57,23.79-5.27s16-3.31,24.08-4.92,16.17-3.15,24.34-4.62l12.25-2.2c4.13-.69,8.21-1.42,12.37-2.07-3.91.94-7.89,1.8-11.84,2.7l-11.95,2.57c-8,1.71-16,3.31-24.08,4.92s-16.16,3.14-24.33,4.62S183.5,305.54,175.2,306.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.79,301.25c7.25-1.74,14.61-3.34,22-4.92s14.83-3.08,22.29-4.56,15-2.92,22.54-4.27l11.35-2c3.83-.63,7.62-1.3,11.48-1.89-3.61.89-7.3,1.68-10.94,2.53l-11.06,2.39c-7.37,1.59-14.83,3.08-22.29,4.56s-15,2.91-22.54,4.27S176.49,300,168.79,301.25Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.46,301.14c9-2.08,18.07-4,27.18-5.94s18.29-3.76,27.48-5.59,18.43-3.59,27.72-5.29l14-2.54c4.69-.79,9.34-1.64,14.07-2.4-4.48,1.06-9,2-13.54,3l-13.65,2.9c-9.1,1.93-18.29,3.76-27.47,5.59s-18.43,3.59-27.73,5.29S143.88,299.59,134.46,301.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.32,294.49c7.94-1.88,16-3.61,24.07-5.33s16.22-3.35,24.37-5,16.35-3.19,24.61-4.68l12.4-2.23c4.17-.7,8.31-1.44,12.51-2.09-4,.95-8,1.81-12,2.73l-12.09,2.59c-8.06,1.73-16.21,3.35-24.36,5s-16.36,3.19-24.62,4.68S141.71,293.15,133.32,294.49Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29,292.74c9-2.08,18.07-4,27.19-5.93S152.77,283,162,281.22s18.43-3.6,27.73-5.29l13.95-2.54c4.69-.8,9.35-1.64,14.07-2.4-4.48,1.05-9,2-13.53,3l-13.65,2.91c-9.1,1.93-18.29,3.76-27.48,5.58s-18.43,3.6-27.73,5.29S116.72,291.2,107.29,292.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.86,279.65c10.45-2.66,21.23-4.92,32.09-7.08s21.86-4.15,33.17-5.78c-10.45,2.66-21.22,4.91-32.09,7.08S150.17,278,138.86,279.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.98 419.2 434.1 386.06 603.06 435.43 428.83 469.76 258.98 419.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,419.2,434.1,385.93s169,49.27,169,49.26l1,.29-1,.2L428.83,469.89C428.78,469.9,259,419.2,259,419.2Zm0,0,169.89,50.44c-.31,0,174.22-34.47,174.14-34.45l0,.48L434.06,386.18c.26-.08-175.12,33.07-175.08,33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.37,459.7c11.41-2.64,23-5.11,34.55-7.54s23.24-4.78,34.91-7.1,23.42-4.57,35.24-6.73l17.73-3.22c6-1,11.87-2.09,17.88-3.05-5.69,1.34-11.47,2.57-17.2,3.86l-17.35,3.68c-11.56,2.46-23.24,4.78-34.91,7.1s-23.42,4.57-35.24,6.72S438.35,457.74,426.37,459.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.26,442.12c12.48-3.21,25.38-5.93,38.38-8.52s26.2-5,39.78-6.88c-12.48,3.22-25.39,5.94-38.39,8.53S484.83,440.2,471.26,442.12Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.11,445.63c10-2.36,20.09-4.54,30.23-6.69s20.37-4.21,30.6-6.25,20.54-4,30.92-5.88l15.58-2.8c5.24-.87,10.43-1.8,15.72-2.62-5,1.2-10,2.29-15,3.43l-15.18,3.26c-10.13,2.17-20.37,4.21-30.6,6.25s-20.55,4-30.93,5.87S419.65,444,409.11,445.63Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,438.5c9.21-2.21,18.57-4.24,28-6.24s18.84-3.92,28.32-5.81,19-3.7,28.64-5.42l14.44-2.58c4.86-.79,9.67-1.65,14.58-2.4-4.59,1.13-9.27,2.14-13.91,3.21l-14.05,3c-9.36,2-18.84,3.91-28.32,5.8s-19,3.7-28.64,5.42S410.74,437,401,438.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.33,438.36c11.41-2.64,23-5.11,34.55-7.54s23.24-4.78,34.91-7.1S450.21,419.15,462,417l17.73-3.22c6-1,11.87-2.09,17.88-3-5.69,1.34-11.47,2.57-17.2,3.86l-17.35,3.68c-11.56,2.46-23.24,4.78-34.91,7.1s-23.42,4.57-35.24,6.72S369.31,436.4,357.33,438.36Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.89,429.91c10.09-2.38,20.33-4.59,30.59-6.76s20.6-4.26,31-6.33,20.78-4.05,31.28-5.94L464.47,408c5.31-.88,10.56-1.82,15.91-2.66-5,1.21-10.15,2.31-15.23,3.47l-15.36,3.3c-10.25,2.19-20.61,4.26-31,6.32s-20.78,4-31.28,5.94S366.55,428.21,355.89,429.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.81,427.69c11.41-2.64,23-5.11,34.55-7.54s23.24-4.78,34.91-7.1,23.42-4.57,35.24-6.73l17.73-3.22c6-1,11.87-2.09,17.87-3.05-5.68,1.34-11.46,2.57-17.19,3.86l-17.35,3.68c-11.56,2.46-23.24,4.78-34.91,7.1s-23.42,4.57-35.24,6.72S334.79,425.73,322.81,427.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.93,411.05c13.28-3.37,27-6.24,40.77-9s27.79-5.28,42.16-7.35c-13.28,3.38-27,6.25-40.78,9S377.3,409,362.93,411.05Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.9,335.21,362.68,424.79V360.22L686.9,270.64C704.08,302.32,686.9,335.21,686.9,335.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.3 380 362.68 424.79 362.68 408.42 75.23 373.26 46.3 375 46.3 380",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.69,360.52c11.82,28.45,0,64.27,0,64.27L61.56,377.23V321.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24,359.56c11.51,28.34.95,58.86.95,58.86L61.56,377v-55.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24,359.56c.39,1.1,1.52,4.2,1.91,5.29a83.2,83.2,0,0,1,3.52,24,100.34,100.34,0,0,1-4.33,29.6c.14.44-294.75-41.11-294.85-41l-.43-.06V377l0-55.6v-.51l.5.07,146.9,19.23,146.72,19.35Zm0,0C283,349.85,131.83,331.93,62,321.42l.05,55.6-.43-.5c0,.11,295.24,41.59,294.4,41.85a95.24,95.24,0,0,0,3.34-14.57c2.23-14.77,1.37-30.27-4.13-44.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.12,345.5c49.16,6,104.22,13.4,153.21,20.67-49.16-6-104.22-13.41-153.21-20.67Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.56,341.76c42.14,5,88.89,11.34,130.88,17.65-42.17-5-88.9-11.32-130.88-17.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.58,347.25c71.61,9,151.84,19.82,223.26,30.11-71.6-9-151.83-19.82-223.26-30.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29,366.14c74.28,9.19,157.51,20.23,231.61,30.71-74.27-9.18-157.5-20.23-231.61-30.71Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.22,377.9C222,386,294.65,395.78,359.28,405.16c-64.81-8.08-137.42-17.88-202.06-27.26Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,377.79c83,10.58,176,23.12,258.79,34.91-83-10.57-176-23.12-258.79-34.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.69 360.52 686.9 270.64 359.28 255.8 46.3 313.84 46.3 319.44 362.69 360.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,350.64c40.22-12.19,81.53-23.2,122.8-32.71-40.21,12.2-81.52,23.19-122.8,32.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.22,344.92c11.2.58,22.77,1.88,33.89,3.23s22.6,3,33.5,5.25c-11.2-.57-22.77-1.88-33.88-3.23s-22.6-3.05-33.51-5.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,314.93c76.15,8.18,152.91,17.83,228.55,28.76C207.34,335.53,130.59,325.86,55,314.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583,307.06q47.46-14.91,96.07-27.17Q631.63,294.8,583,307.06Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glasses--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.89,257.81c-4.2.82-21.54,1.75-21.89-2-.54-5.64,40.93-45.64,55.81-53.16,14.15-7.16,59.74-22.78,71-23.12l.1,35.92c-6.37,1.62-57.12-3.33-67.78,2.33-4.63,2.46-10.76,12.66-23.24,28.86C424.5,252.35,417.37,257.32,414.89,257.81Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.89,257.81c-4.2.82-21.54,1.75-21.89-2-.54-5.64,40.93-45.64,55.81-53.16,14.15-7.16,59.74-22.78,71-23.12l.1,35.92c-6.37,1.62-57.12-3.33-67.78,2.33-4.63,2.46-10.76,12.66-23.24,28.86C424.5,252.35,417.37,257.32,414.89,257.81Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M406.28,257.81c-4.21.82-20.33,1.75-20.69-2-.53-5.64,40.94-45.64,55.81-53.16,14.15-7.16,67.15-22.78,78.41-23.12l.1,35.92c-6.37,1.62-64.52-3.33-75.18,2.33-4.63,2.46-12,12.66-24.46,28.86C415.89,252.35,408.76,257.32,406.28,257.81Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.28,257.81c-4.21.82-20.33,1.75-20.69-2-.53-5.64,40.94-45.64,55.81-53.16,14.15-7.16,67.15-22.78,78.41-23.12l.1,35.92c-6.37,1.62-64.52-3.33-75.18,2.33-4.63,2.46-12,12.66-24.46,28.86C415.89,252.35,408.76,257.32,406.28,257.81Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M569.79,305.47c3.62,1.52,17.86,2.29,20.3-.78,3.68-4.65-41.22-67.92-67.6-79.4-24.67-10.65-372.72-78.25-379.9-79.37L142.33,174c48.49,7.58,356.17,56.6,375.2,64.89,12.41,5.39,28.22,33.83,39.58,53.48C561.7,300.35,565.59,303.71,569.79,305.47Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M569.79,305.47c3.62,1.52,17.86,2.29,20.3-.78,3.68-4.65-41.22-67.92-67.6-79.4-24.67-10.65-372.72-78.25-379.9-79.37L142.33,174c48.49,7.58,356.17,56.6,375.2,64.89,12.41,5.39,28.22,33.83,39.58,53.48C561.7,300.35,565.59,303.71,569.79,305.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M563.78,305.47c3.62,1.52,17.86,2.29,20.3-.78,3.68-4.65-40.89-69.45-67.26-80.93C492.14,213.11,149.77,147,142.59,145.92L136.32,174c48.49,7.58,356.17,56.6,375.2,64.89,12.41,5.39,28.22,33.83,39.58,53.48C555.69,300.35,559.58,303.71,563.78,305.47Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M563.78,305.47c3.62,1.52,17.86,2.29,20.3-.78,3.68-4.65-40.89-69.45-67.26-80.93C492.14,213.11,149.77,147,142.59,145.92L136.32,174c48.49,7.58,356.17,56.6,375.2,64.89,12.41,5.39,28.22,33.83,39.58,53.48C555.69,300.35,559.58,303.71,563.78,305.47Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210,158.88l-26.34,22.65c-21.91-3.5-38.72-6.15-47.32-7.5l6.26-28.11C144.55,146.22,171.42,151.37,210,158.88Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M277.36,196.69,261,194h0l-15.2-28.12,24.09,4.76Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M369.5,190.66,351,208.89h0l-16.43-2.76,13.14-19.91Q358.66,188.43,369.5,190.66Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M514.56,222.93l-6.37,14.89c-3.06-.86-7.67-1.94-13.6-3.19L490,216.48C501.54,219.2,510.06,221.41,514.56,222.93Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M208.74,320.18c-36.26-1.75-63.85-42.82-61.51-91.54,1.11-23.25,8.8-44.87,21.64-60.88,13.27-16.54,30.4-25.22,48.4-24.31s34.22,11.11,45.83,28.86c11.25,17.14,16.83,39.41,15.7,62.68-2.22,46.1-30.48,82.8-64.25,85.13A51.1,51.1,0,0,1,208.74,320.18Zm-30.64-145C166.81,189.23,160,208.43,159,229.22c-2,42.2,20.53,77.71,50.29,79.14s55.63-31.74,57.68-74c1-20.79-3.91-40.54-13.78-55.63-9.51-14.49-22.48-22.84-36.52-23.51a37.32,37.32,0,0,0-4.49,0C199.74,156.17,187.78,163.1,178.1,175.16Zm-30.82,59.65c-1.83-35.64,2.16-41.22.54-51.73-.77-5-7.81-9.8-7.81-9.8l6.15-25.59s19.17,1.87,23.59,1.94c7.86.11,24.83-5.63,39.61-6,0,0-32.13,14.44-42.46,32.85S147.28,234.81,147.28,234.81Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.74,320.18c-36.26-1.75-63.85-42.82-61.51-91.54,1.11-23.25,8.8-44.87,21.64-60.88,13.27-16.54,30.4-25.22,48.4-24.31s34.22,11.11,45.83,28.86c11.25,17.14,16.83,39.41,15.7,62.68-2.22,46.1-30.48,82.8-64.25,85.13A51.1,51.1,0,0,1,208.74,320.18Zm-30.64-145C166.81,189.23,160,208.43,159,229.22c-2,42.2,20.53,77.71,50.29,79.14s55.63-31.74,57.68-74c1-20.79-3.91-40.54-13.78-55.63-9.51-14.49-22.48-22.84-36.52-23.51a37.32,37.32,0,0,0-4.49,0C199.74,156.17,187.78,163.1,178.1,175.16Zm-30.82,59.65c-1.83-35.64,2.16-41.22.54-51.73-.77-5-7.81-9.8-7.81-9.8l6.15-25.59s19.17,1.87,23.59,1.94c7.86.11,24.83-5.63,39.61-6,0,0-32.13,14.44-42.46,32.85S147.28,234.81,147.28,234.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.81,320.18c-36.27-1.75-63.86-42.82-61.52-91.54,1.11-23.25,8.8-44.87,21.64-60.88,13.27-16.54,30.4-25.22,48.4-24.31s34.22,11.11,45.83,28.86c11.25,17.14,16.83,39.41,15.7,62.68-2.22,46.1-30.48,82.8-64.25,85.13A51,51,0,0,1,203.81,320.18Zm-30.65-145c-11.29,14.07-18.06,33.27-19.06,54.06-2,42.2,20.52,77.71,50.28,79.14s55.63-31.74,57.68-74c1-20.79-3.91-40.54-13.78-55.63-9.5-14.49-22.48-22.84-36.52-23.51a37.32,37.32,0,0,0-4.49,0C194.81,156.17,182.84,163.1,173.16,175.16Zm-30.82,59.65c-1.83-35.64,2.16-41.22.54-51.73-.77-5-7.81-9.8-7.81-9.8l6.43-28.52s19.49,3.45,23.9,3.51c7.86.12,24.24-4.27,39-4.6,0,0-32.13,14.44-42.46,32.85S142.34,234.81,142.34,234.81Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.72,157.83c-.23,1.77-3.52,2.79-7.35,2.28s-6.73-2.36-6.49-4.12,3.52-2.79,7.35-2.28S161,156.06,160.72,157.83Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.56,156.05c.31-.85,3.64-1.81,7.28-.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,173.53c6.92,3.88,9.88,9.6,9.1,17.52-.77,13.74-2.32,27.35-2.34,41.09a131.7,131.7,0,0,0,1.32,20.5c-4.43-16.74-3.11-34.39-1.55-51.44l1-10.24c1.08-7.66-1.34-12.9-7.55-17.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14,149.94c9.6-2.74,19.57-5,29.61-4.55-10,.89-19.71,3.13-29.61,4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.13,175.89c-10.91,14-17.45,33.08-18.43,53.76-1.95,42,19.85,77.28,48.61,78.71s53.77-31.57,55.75-73.55c1-20.67-3.77-40.32-13.31-55.32-9.19-14.42-21.73-22.72-35.31-23.39a34.9,34.9,0,0,0-4.34,0C197.05,157,185.49,163.88,176.13,175.89Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.32,161.74l-73.7,75.83c-.07-2.62,0-5.25.09-7.93a107.78,107.78,0,0,1,3.58-23.15l49-50.39c1,0,2.11,0,3.17,0A38,38,0,0,1,231.32,161.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,197l-85.83,88.31a72.38,72.38,0,0,1-4.28-7.61l86.71-89.22A80.86,80.86,0,0,1,257,197Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.34,249.76a101.85,101.85,0,0,1-4.58,16.73l-39.95,41.1a36.3,36.3,0,0,1-9.5.77c-.9-.05-1.8-.12-2.69-.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5,210.59,178.65,294.8c-.39-.38-.76-.78-1.12-1.19l82.59-85C260.27,209.27,260.38,209.94,260.5,210.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.72,237.17l8-8.69c-12.86-11.9-43.13-28.52-65.81-6.47l8.24,8.48C292.47,210.7,320.53,236.09,321.72,237.17Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.26,331A88.58,88.58,0,0,1,327.11,228h0A88.51,88.51,0,1,1,398.26,331ZM338.75,230.16a76.56,76.56,0,1,0,70.13-62.71A76.74,76.74,0,0,0,338.75,230.16Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493,206.12c-6.09-20.22-41.56-42.45-41.56-42.45,14.36,3.53,30.2,10.71,37.9,12.31,4.32.89,30.52,3.57,30.52,3.57l.1,35.92s-7.2.4-9,5.11c-3.86,9.91-1.91,12.31-11.43,46.69C499.44,267.27,499,226.33,493,206.12Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M398.26,331A88.58,88.58,0,0,1,327.11,228h0A88.51,88.51,0,1,1,398.26,331ZM338.75,230.16a76.56,76.56,0,1,0,70.13-62.71A76.74,76.74,0,0,0,338.75,230.16Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M493,206.12c-6.09-20.22-41.56-42.45-41.56-42.45,14.36,3.53,30.2,10.71,37.9,12.31,4.32.89,30.52,3.57,30.52,3.57l.1,35.92s-7.2.4-9,5.11c-3.86,9.91-1.91,12.31-11.43,46.69C499.44,267.27,499,226.33,493,206.12Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M390.39,329.71A88.58,88.58,0,0,1,319.24,226.8h0a88.55,88.55,0,1,1,71.15,102.92ZM330.88,228.92A76.61,76.61,0,1,0,401,166.22,76.74,76.74,0,0,0,330.88,228.92Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.08,204.88c-6.09-20.22-41.56-42.45-41.56-42.45,14.36,3.53,30.2,10.71,37.9,12.31,4.32.89,30.52,3.57,30.52,3.57l.1,32.89s-7.2,2.18-9,6.88c-3.87,9.91-1.92,13.57-11.44,48C491.57,266,491.17,225.09,485.08,204.88Z",
    style: {
      fill: "#FB4E4E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.72,193.08c-.24,1.77-3.53,2.79-7.35,2.28s-6.74-2.35-6.5-4.12,3.53-2.79,7.35-2.28S501,191.32,500.72,193.08Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.55,191.31c.31-.85,3.64-1.82,7.28-.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.83,168.87a43,43,0,0,1,26.4-8.79c-9,2.64-17.66,5.5-26.4,8.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.38,213c4.48-17.89,19.44-35.15,35.91-43.2-15.42,11-28.35,25.76-35.91,43.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.53,228.92c-7.4,41.57,19.58,81.57,60.16,89.16s79.6-20.07,87-61.63-19.59-81.58-60.17-89.16A72.46,72.46,0,0,0,403,166.22C369.67,168.57,340.79,193.77,334.53,228.92Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.84,246.22l-71.29,73a73.05,73.05,0,0,1-16.86-1.18,70.5,70.5,0,0,1-7.13-1.71L480,221.64A77.38,77.38,0,0,1,482.84,246.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.7,166.68l-83.77,85.84a78.46,78.46,0,0,1,.6-23.6c.34-1.94.77-3.87,1.25-5.76L389,168.59A72.67,72.67,0,0,1,403,166.22,71.43,71.43,0,0,1,417.7,166.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.69,200.79l-103.49,106a71.05,71.05,0,0,1-6.79-5.13L465.7,193.83A73.6,73.6,0,0,1,470.69,200.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.31,172.55l-98.62,101a76.47,76.47,0,0,1-3.18-8.82l93.19-95.48A74.09,74.09,0,0,1,438.31,172.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.88,255.39c-.05.35-.12.71-.18,1.06-.1.62-.22,1.24-.35,1.84l-58,59.44c-.93.2-1.88.38-2.84.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.81,187.33,354.09,295.65c-.38-.4-.75-.81-1.11-1.22L458.63,186.18Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingglassesCuate);
export default __webpack_public_path__ + "static/media/Reading glasses-cuate.7d5c4ebdb41edca91cea455e5afd3969.svg";
export { ForwardRef as ReactComponent };